
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { getter } from '../../../../utility/fp';
import { orderDetailsLens, orderLinesLens, contactLens, addressTypeLens, countriesLens, backordersLens,orderstatusLens,labelsLens,productTypeLens,
  invoiceProjectsLens,currenciesLens,paymentMethodLens,shippingTypesLens,stockAccountLens,orderTypeLens,orderSummaryLens ,orderAccountLens} from './state';
export const distributionOrderGetters = {
  distributionOrderData: (state) => state.distributionOrderData,
  distributionOrderList: (state)=> state.distributionOrderList,
  distributionOrderDetails: (state)=> state.distributionOrderDetails,
}

